import React, { useEffect, useState } from 'react'
import { HiShieldCheck } from 'react-icons/hi'
import cookies from '../../../../../CommonFunction/cookies'
import { fetchIndividualData } from '../../../../../API/ClevDocContact'
import Loader from '../../../../../CommonFunction/Loader'
import { useNavigate } from 'react-router-dom'
import { showToast } from '../../../../../CommonFunction/Toast'
import { capitalizeFirstLetter } from '../../Pages/Widget'
import { usePDF } from 'react-to-pdf'
import axios from 'axios'
import {
  showFailed,
  showWarning
} from '../../../../../CommonFunction/SweetAlert'
import { UploadPOR } from '../../../../../API/Borrower/UploadPOR'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

const IndividualCertificate = () => {
  const [base64Logo, setBase64Logo] = useState(null)
  const [base64Digi, setBase64Digi] = useState(null)
  const [base64QrCode, setBase64QrCode] = useState(null) // State for QR code
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [userData, setUserData] = useState([])
  const { toPDF, targetRef } = usePDF({ filename: `${userData?.first_name || ''}_POR.pdf` })
  const jwtToken = cookies.get('jwt')

  const imageUrl =
    'https://cdn.clevdoc.com/assets/dashboard/banking/borrower/clevdoc_logo.png'
  const digitalIndia =
    'https://cdn.clevdoc.com/assets/dashboard/banking/borrower/digital_india.png'

  function arrayBufferToBase64 (buffer) {
    let binary = ''
    const bytes = new Uint8Array(buffer)
    const len = bytes.byteLength
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i])
    }
    return btoa(binary)
  }

  const convertImageToBase64 = async imageUrl => {
    try {
      const response = await axios.get(imageUrl, {
        responseType: 'arraybuffer'
      })
      if (response.status !== 200) {
        throw new Error('Failed to fetch image')
      }
      const arrayBuffer = response.data
      const base64String = arrayBufferToBase64(arrayBuffer)
      return base64String
    } catch (error) {
      console.error('Error converting image to Base64:', error)
      throw error
    }
  }

  useEffect(() => {
    const fetchDataAndUpdateUserData = async () => {
      setLoading(true)
      try {
        const data = await fetchIndividualData(jwtToken)
        setUserData(data)
        if (data?.por && data?.por.length === 0) {
          setTimeout(() => {
            uploadPOR()
          }, 100)
        }

        setLoading(false)
      } catch (error) {
        showFailed('Failed.', `${error}`)
        setLoading(false)
      }
    }

    fetchDataAndUpdateUserData()
  }, [jwtToken])

  useEffect(() => {
    if (userData?.por_envelope_id) {
      const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?data=https://www.clevdoc.com/verifyUser?number=${userData.por_envelope_id}&size=200x200`
      const convertImages = async () => {
        try {
          const base64Logo = await convertImageToBase64(imageUrl)
          const base64Digi = await convertImageToBase64(digitalIndia)
          const base64QrCode = await convertImageToBase64(qrCodeUrl)

          setBase64Logo(`data:image/png;base64,${base64Logo}`)
          setBase64Digi(`data:image/png;base64,${base64Digi}`)
          setBase64QrCode(`data:image/png;base64,${base64QrCode}`)
        } catch (error) {
          console.error('Error converting images to Base64:', error)
        }
      }

      convertImages()
    }
  }, [userData])

  const formatDate = inputDate => {
    const date = new Date(inputDate)
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const seconds = date.getSeconds().toString().padStart(2, '0')

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`
  }

  useEffect(() => {
    if (userData && userData?.step === 1) {
      showWarning(
        'Profile Incomplete...',
        'Your Profile is not completed, please complete your profile first'
      )
      navigate('/banking/borrowerDashboard/1')
    } else if (userData && userData?.step === 2 && !userData.payment) {
      showWarning(
        'Payment Incomplete...',
        'Your Payment is not completed, please complete your Payment first'
      )
      navigate('/banking/purchaseSummary')
    }
  }, [userData, navigate])

  const downloadPdf = () => {
    if (!targetRef.current) return

    toPDF(targetRef.current)
    navigate('/banking/borrowerDashboard/inbox')
  }

  const printPdf = e => {
    e.preventDefault()
    let printContents = document.getElementById('pdf-content').innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print()
    setTimeout(() => {
      document.body.innerHTML = originalContents
      navigate('/banking/borrowerDashboard/inbox')
      window.location.reload(true)
    }, 100)
  }

  // Function to capture the PDF and upload it
  const uploadPOR = () => {
    if (!targetRef.current) return

    setTimeout(() => {
      html2canvas(targetRef.current)
        .then(canvas => {
          const imgData = canvas.toDataURL('image/png')
          const pdf = new jsPDF('p', 'mm', 'a4')
          const imgWidth = 210
          const pageHeight = 295
          const imgHeight = (canvas.height * imgWidth) / canvas.width
          let heightLeft = imgHeight
          let position = 0

          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
          heightLeft -= pageHeight

          while (heightLeft >= 0) {
            position = heightLeft - imgHeight
            pdf.addPage()
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
            heightLeft -= pageHeight
          }

          const pdfBlob = pdf.output('blob')
          const file = new File([pdfBlob], 'certificate.pdf', {
            type: 'application/pdf'
          })
          const formData1 = new FormData()
          formData1.append('file', file)
          UploadPOR(jwtToken, formData1)
        })
        .catch(error => {
          console.error('Error generating PDF:', error)
        })
    }, 2000)
  }

  if (loading) {
    return <Loader />
  }

  const formattedDate = formatDate(userData?.updated_at)

  return (
    <>
      <div className='bg-gray-200'>
        <div className='py-10 font-avenir'>
          <div className='container'>
            <div className='flex justify-end p-5'>
              <button
                className='bg-btnclr hover:bg-hover-clr py-2 px-2 text-txtclr rounded-lg mr-2'
                onClick={downloadPdf}
              >
                Download
              </button>
              <button
                className='bg-btnclr py-2 px-4 text-txtclr rounded-lg'
                onClick={e => printPdf(e)}
              >
                Print
              </button>
            </div>
          </div>
          <div className='overflow-auto md:p-0 p-3 md:mx-0 mx-1 md:border-none border-2 border-bgclr rounded-xl'>
            <div
              ref={targetRef}
              id='pdf-content'
              className='mx-auto w-[820px] bg-bgclr9 border border-bgclr'
            >
              <div
                style={{
                  backgroundColor: '#0B1E59',
                  padding: '10px',
                  display: 'flex',
                  justifyContent: 'space-between'
                }}
              >
                <div>
                  <img
                    className='w-64 mt-5 ml-3'
                    src={base64Logo}
                    alt='Not available'
                  />
                </div>
                <div className='flex'>
                  <img className='w-40' src={base64Digi} alt='Not available' />
                </div>
              </div>

              <div className='mt-5 mb-7'>
                <h1 className='text-center text-4xl  font-bold text-txtclr3'>
                  PROOF OF REGISTRATION
                </h1>
              </div>

              <div className='flex justify-between'>
                <h1 className='text-xl ml-16 pb-2 text-txtclr2 underline font-semibold'>
                  User Details
                </h1>
              </div>
              <div className='ml-12 mr-5 pl-8 mb-4 border-2 rounded-xl '>
                <div className='flex justify-end mr-4'>
                  <p className='text-gray-500'>
                    Envelope_ID: {userData?.por_envelope_id || ''}
                  </p>
                </div>
                <table className='text-md mt-3 mb-5 leading-8'>
                  <tr className=''>
                    <td>Date of Generation : </td>
                    <td className='pl-8 font-semibold'>{formattedDate}</td>
                  </tr>
                  <tr className=''>
                    <td>UCI : </td>
                    <td className='pl-8 font-thin'>{userData?.system_id}</td>
                  </tr>
                  <tr className=''>
                    <td>Name : </td>
                    <td className='pl-8 font-semibold'>
                      {capitalizeFirstLetter(userData?.first_name)}{' '}
                      {capitalizeFirstLetter(userData?.middle_name)}{' '}
                      {capitalizeFirstLetter(userData?.last_name)}
                    </td>
                  </tr>
                  <tr>
                    <td>Gender : </td>
                    <td className='pl-8 font-semibold'>
                      {capitalizeFirstLetter(userData?.gender)}
                    </td>
                  </tr>
                  <tr>
                    <td>Aadhaar No. : </td>
                    <td className='flex pl-8 font-semibold'>
                      {userData?.personal?.adhaar_card?.number}{' '}
                      {userData?.personal?.adhaar_card?.number && (
                        <HiShieldCheck
                          size={23}
                          className='mt-0.5 text-green-700'
                        />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Email ID : </td>
                    <td className='flex pl-8 font-semibold'>
                      {userData?.email}
                      <HiShieldCheck
                        size={23}
                        className='mt-0.5 text-green-700'
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Mobile No. : </td>
                    <td className='flex pl-8 font-semibold'>
                      {userData?.phone_number}{' '}
                      {userData?.phone_number && (
                        <HiShieldCheck
                          size={23}
                          className='mt-0.5 text-green-700'
                        />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>WhatsApp : </td>
                    <td className='flex pl-8 font-semibold'>
                      {userData?.personal?.whatsapp}{' '}
                      {userData?.personal?.whatsapp && (
                        <HiShieldCheck
                          size={23}
                          className='mt-0.5 text-green-700'
                        />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>PAN Number : </td>
                    <td className='flex pl-8 font-semibold'>
                      {userData?.personal?.pancard}{' '}
                      {userData?.personal?.pancard && (
                        <HiShieldCheck
                          size={23}
                          className='mt-0.5 text-green-700'
                        />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Current Address :</td>
                    <td className='pl-8 font-semibold'>
                      {userData?.address?.current_address}
                    </td>
                  </tr>
                  <tr>
                    <td>Permanent Address :</td>
                    <td className='pl-8 font-semibold'>
                      {userData?.address?.permanent_address}
                    </td>
                  </tr>
                  <tr>
                    <td>Alternate Number : </td>
                    <td className='pl-8 font-semibold'>
                      {userData?.alternate_contacts?.phone_number}
                    </td>
                  </tr>
                  <tr>
                    <td>Alternate Email ID :</td>
                    <td className='pl-8 font-semibold'>
                      {userData?.alternate_contacts?.email}
                    </td>
                  </tr>
                </table>
              </div>

              <div className='grid grid-cols-5 bg-gray-300 p-5 px-10 gap-10'>
                <div className='col-span-3'>
                  <div>
                    <h1 className='text-2xl font-bold text-txtclr3'>
                      ClevDoc Platforms Inc.
                    </h1>
                  </div>
                  <div>
                    <p className='flex text-justify text-lg pt-5 border-r-2 pr-10 border-bgclr2'>
                      To verify the authenticity of this Registration
                      Certificate, please scan the QR or visit the
                      https/clevdoc.com/verify. In case of any queries, you can
                      email us at support@clevdoc.com
                    </p>
                  </div>
                </div>
                <div className='grid pl-8'>
                  <div className='flex items-center w-56'>
                    <img
                      src={base64QrCode}
                      className='w-56 mr-2'
                      alt='QR Code'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default IndividualCertificate
